import React from 'react';
import './DevicesPage.css';
import '../meteringPage/MeteringPage.css';
import { connect } from 'react-redux';
import { t } from 'i18next';
import { AYLA_ALLOWED_ROLES, REGIONS, REGIONS_FOR_VPC, REGIONS_FOR_EU, REGIONS_FOR_US, GoogleAnalyticsConstants } from '../../../constants';
import { stringToNumberLocale } from '../../../helpers/formatter';
import * as reportsservice from '../../../services/reportsservice';
import BarChart from '../../reports/barChartReport/BarChartReport';
import DataSnapshot from '../../aylaTimeZone/AylaTimeZone';
import FilterPanel, {
  date_range, oem_id, region_name, oem_model
} from '../../filters/filterPanel/FilterPanel';
import MeteringNavBar from '../../meteringNavBar/MeteringNavBar';
import ReportPage from '../ReportPage';
import TimeAggregation from '../../filters/timeAggregationFilter/TimeAggregationFilter';
import TitleBar from '../../titleBar/TitleBar';
import ValueDisplayReport from '../../reports/meteringValueDisplayReport/valueDisplayReport';
import { logPageViewEvent } from '../../../services/analyticsservice';

class DevicesPage extends ReportPage {
  // this is needed when page has dependency on contracts data and will tell to reportsPage to call the contractData
  isContractDataRequired = true;

  quarterToDateAvg = null;
  prevQuarterAvg = null;
  twoQuartersAgoAvg = null;

  googleAnalytics() {
    const { logged_in_oem_id } = this.props.presistFilters;
    logPageViewEvent(GoogleAnalyticsConstants.Metering.title, logged_in_oem_id);
  }

  reports() {
    const filters = this.props.presistFilters;
    const isUsFieldDpMeteringOem = (this.props.presistFilters.region_name === 'US-FIELD'
      && this.us_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isEuFieldDpMeteringOem = (this.props.presistFilters.region_name === 'EU'
        && this.eu_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isSharkVpc = (((this.props.presistFilters.region_name === 'US-VPC') || (this.props.presistFilters.region_name === 'EU'))
        && this.props.presistFilters.oem_id === '39a9391a');
    filters.dsns = null;
    return {
      filters: [
        reportsservice.listOfOems(filters),
        reportsservice.contractlistOfOemModels(filters),
      ],
      reports: (isUsFieldDpMeteringOem || isEuFieldDpMeteringOem || isSharkVpc) ? [
        reportsservice.dsnReservedOverTime(filters),
        reportsservice.devicesProvisionedOverTime(filters),
        reportsservice.devicesActivatedOverTime(filters),
        reportsservice.activeDevice(filters),
        reportsservice.dsnReserved(filters),
        reportsservice.devicesProvisioned(filters),
        reportsservice.devicesActivated(filters),
        reportsservice.quarterToDateTransactionsPerDevice(filters),
        reportsservice.quarterToDateTotalTransactions(filters),
        reportsservice.previousQuarterTransactionsPerDevice(filters),
        reportsservice.previousQuarterTotalTransactions(filters),
        reportsservice.twoQuartersAgoTransactionsPerDevice(filters),
        reportsservice.twoQuartersAgoTotalTransactions(filters),
      ] : [
        reportsservice.dsnReservedOverTime(filters),
        reportsservice.devicesProvisionedOverTime(filters),
        reportsservice.devicesActivatedOverTime(filters),
        reportsservice.activeDevice(filters),
        reportsservice.dsnReserved(filters),
        reportsservice.devicesProvisioned(filters),
        reportsservice.devicesActivated(filters),
        reportsservice.transactionsPerDeviceQuarterToDate(filters),
        reportsservice.transactionsPerDevicePreviousQuarter(filters),
        reportsservice.transactionsPerDeviceTwoQuartersAgo(filters),
      ],
    };
  }

  reportsDescription = () => [
    reportsservice.dsnReservedOverTime(),
    reportsservice.devicesProvisionedOverTime(),
    reportsservice.devicesActivatedOverTime(),
    reportsservice.activeDevice(),
    reportsservice.dsnReserved(),
    reportsservice.devicesProvisioned(),
    reportsservice.devicesActivated(),
    reportsservice.transactionsPerDeviceQuarterToDate(),
    reportsservice.transactionsPerDevicePreviousQuarter(),
    reportsservice.transactionsPerDeviceTwoQuartersAgo()
  ];

  getDaysInQuarter = () => {
    var days_in_a_quarter = {};
    var d = new Date();
    var quarter = Math.floor((d.getMonth() / 3));
    // current quarter
    var cur_quarter_firstDate = new Date(d.getFullYear(), quarter * 3, 1);
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    days_in_a_quarter.cur_quarter_duration = Math.round(Math.abs((new Date(cur_quarter_firstDate) - new Date(d)) / oneDay));

    // previous quarter
    var prev_quarter_firstDate = new Date(d.getFullYear(), quarter * 3 - 3, 1);
    var prev_quarter_endDate = new Date(prev_quarter_firstDate.getFullYear(), prev_quarter_firstDate.getMonth() + 3, 0);
    days_in_a_quarter.prev_quarter_duration = Math.round(Math.abs((new Date(prev_quarter_firstDate) - new Date(prev_quarter_endDate)) / oneDay));

    // two quarters ago
    var two_quarters_ago_firstDate = new Date(d.getFullYear(), quarter * 3 - 6, 1);
    var two_quarters_ago_endDate = new Date(two_quarters_ago_firstDate.getFullYear(), two_quarters_ago_firstDate.getMonth() + 3, 0);
    days_in_a_quarter.two_quarters_ago_duration = Math.round(Math.abs((new Date(two_quarters_ago_firstDate) - new Date(two_quarters_ago_endDate)) / oneDay));
    return days_in_a_quarter;
  };

  render() {
    const { fetchData, isMeteringApi, session } = this.props;
    const hideDevicesReserved = process.env.REACT_APP_HIDE_DEVICES_RESERVED;

    if (isMeteringApi) {
      var days_in_quarter = this.getDaysInQuarter();
      // Quarter to date average
      if (this.report(reportsservice.quarterToDateTransactionsPerDevice)
        && this.report(reportsservice.quarterToDateTotalTransactions)){
        if (this.report(reportsservice.quarterToDateTotalTransactions).total === '0') {
          this.quarterToDateAvg = '0';
        } else if (this.report(reportsservice.quarterToDateTransactionsPerDevice) !== '0'
          && (!(this.report(reportsservice.quarterToDateTransactionsPerDevice).hasOwnProperty('message')))) {
          this.quarterToDateAvg = Math.floor(this.report(reportsservice.quarterToDateTotalTransactions).total /
            (this.report(reportsservice.quarterToDateTransactionsPerDevice) * days_in_quarter.cur_quarter_duration));
        } else {
          this.quarterToDateAvg = '0';
        }
      }
      // Previous quarter average
      if (this.report(reportsservice.previousQuarterTransactionsPerDevice)
        && this.report(reportsservice.previousQuarterTotalTransactions)){
        if (this.report(reportsservice.previousQuarterTotalTransactions).total === '0') {
          this.prevQuarterAvg = '0';
        } else if(this.report(reportsservice.previousQuarterTransactionsPerDevice) !== '0'
          && (!(this.report(reportsservice.previousQuarterTransactionsPerDevice).hasOwnProperty('message')))) {
          this.prevQuarterAvg = Math.floor(this.report(reportsservice.previousQuarterTotalTransactions).total /
            (this.report(reportsservice.previousQuarterTransactionsPerDevice) * days_in_quarter.prev_quarter_duration));
        } else {
          this.prevQuarterAvg = '0';
        }
      }
      // Two quarters ago
      if (this.report(reportsservice.twoQuartersAgoTransactionsPerDevice)
        && this.report(reportsservice.twoQuartersAgoTotalTransactions)){
        if (this.report(reportsservice.twoQuartersAgoTotalTransactions).total === '0') {
          this.twoQuartersAgoAvg = '0';
        } else if(this.report(reportsservice.twoQuartersAgoTransactionsPerDevice) !== '0'
          && (!(this.report(reportsservice.twoQuartersAgoTransactionsPerDevice).hasOwnProperty('message')))) {
          this.twoQuartersAgoAvg = Math.floor(this.report(reportsservice.twoQuartersAgoTotalTransactions).total /
            (this.report(reportsservice.twoQuartersAgoTransactionsPerDevice) * days_in_quarter.two_quarters_ago_duration));
        } else {
          this.twoQuartersAgoAvg = '0';
        }
      }
    }

    return (
      <div className="DevicesPage page">
        <TitleBar title="Billing Data" />
        <MeteringNavBar />
        <div className="page-content-wrapper metering-page-content-wrapper container-flex">
          <div className="pageContent metering-page-content">
          <FilterPanel disabled={fetchData.fetches > 0}
            currentFilters={this.props.presistFilters}
            filters={[
              AYLA_ALLOWED_ROLES.includes(session.role) && oem_id(this.report(reportsservice.listOfOems)),
              date_range,
              process.env.REACT_APP_IS_VPC_ENVIRNOMENT === 'true'
                ? region_name(REGIONS_FOR_VPC)
                : process.env.REACT_APP_IS_US_ENVIRNOMENT === 'true'
                ? region_name(REGIONS_FOR_US)
                : process.env.REACT_APP_IS_EU_ENVIRNOMENT === 'true'
                  ? region_name(REGIONS_FOR_EU)
                  : region_name(REGIONS),
              oem_model(this.report(reportsservice.contractlistOfOemModels)),
            ]}
            hideDefaultReports
          />
          <DataSnapshot snapShot={this.dataSnapshotTime} />
          <div className="container-space-between">
            <ValueDisplayReport title="meteringPage.deviceCounts"
              data={{
                details: {
                  ...(hideDevicesReserved === 'true') ? null :
                  { 'meteringPage.device.reserved': {
                      report: (this.report(reportsservice.dsnReserved)
                        && this.report(reportsservice.dsnReserved).hasOwnProperty('message'))
                        ? t('unableToFetchData')
                        : stringToNumberLocale(this.report(reportsservice.dsnReserved)),
                      reportDescription: this.reportDescription(reportsservice.dsnReserved)
                    }
                  },
                  'meteringPage.device.provisioned': {
                    report: (this.report(reportsservice.devicesProvisioned)
                      && this.report(reportsservice.devicesProvisioned).hasOwnProperty('message'))
                      ? t('unableToFetchData')
                      : stringToNumberLocale(this.report(reportsservice.devicesProvisioned)),
                    reportDescription: this.reportDescription(reportsservice.devicesProvisioned)
                  },
                  'meteringPage.device.activated': {
                    report: (this.report(reportsservice.devicesActivated)
                      && this.report(reportsservice.devicesActivated).hasOwnProperty('message'))
                      ? t('unableToFetchData')
                      : stringToNumberLocale(this.report(reportsservice.devicesActivated)),
                    reportDescription: this.reportDescription(reportsservice.devicesActivated)
                  },
                  'meteringPage.device.active': {
                    report: (this.report(reportsservice.activeDevice)
                      && this.report(reportsservice.activeDevice).hasOwnProperty('message'))
                      ? t('unableToFetchData')
                      : stringToNumberLocale(this.report(reportsservice.activeDevice)),
                    reportDescription: this.reportDescription(reportsservice.activeDevice)
                  }
                },
                id: ['reserved', 'provisioned', 'activated', 'active'],
              }}
            />
            {! isMeteringApi && <ValueDisplayReport title="meteringPage.averageDailyTransactionsPerDevice"
              data={{
                details: {
                  'meteringPage.device.quarterToDate': {
                    report: (this.report(reportsservice.transactionsPerDeviceQuarterToDate)
                      && (this.report(reportsservice.transactionsPerDeviceQuarterToDate).hasOwnProperty('message')))
                      ? t('unableToFetchData')
                      : (this.report(reportsservice.transactionsPerDeviceQuarterToDate)
                        && Number.isNaN(Number(this.report(reportsservice.transactionsPerDeviceQuarterToDate))))
                        ? t('notComputable')
                        : stringToNumberLocale(this.report(reportsservice.transactionsPerDeviceQuarterToDate)),
                    reportDescription: this.reportDescription(reportsservice.transactionsPerDeviceQuarterToDate)
                  },
                  'meteringPage.device.previousQuarter': {
                    report: (this.report(reportsservice.transactionsPerDevicePreviousQuarter)
                      && this.report(reportsservice.transactionsPerDevicePreviousQuarter).hasOwnProperty('message'))
                      ? t('unableToFetchData')
                      : (this.report(reportsservice.transactionsPerDevicePreviousQuarter)
                        && Number.isNaN(Number(this.report(reportsservice.transactionsPerDevicePreviousQuarter))))
                        ? t('notComputable')
                        : stringToNumberLocale(this.report(reportsservice.transactionsPerDevicePreviousQuarter)),
                    reportDescription: this.reportDescription(reportsservice.transactionsPerDevicePreviousQuarter)
                  },
                  'meteringPage.device.TwoQuartersAgo': {
                    report: (this.report(reportsservice.transactionsPerDeviceTwoQuartersAgo)
                      && this.report(reportsservice.transactionsPerDeviceTwoQuartersAgo).hasOwnProperty('message'))
                      ? t('unableToFetchData')
                      : (this.report(reportsservice.transactionsPerDeviceTwoQuartersAgo)
                        && Number.isNaN(Number(this.report(reportsservice.transactionsPerDeviceTwoQuartersAgo))))
                        ? t('notComputable')
                        : stringToNumberLocale(this.report(reportsservice.transactionsPerDeviceTwoQuartersAgo)),
                    reportDescription: this.reportDescription(reportsservice.transactionsPerDeviceTwoQuartersAgo)
                  },
                },
                id: ['quarter-to-date', 'previous-quarter', 'two-quarters-ago']
              }}
            />}
            {isMeteringApi &&
              <ValueDisplayReport
                title="meteringPage.averageDailyTransactionsPerDevice"
                data={{
                  details: {
                    'meteringPage.device.quarterToDate': {
                      report: ((this.report(reportsservice.quarterToDateTransactionsPerDevice)
                        && this.report(reportsservice.quarterToDateTransactionsPerDevice).hasOwnProperty('message'))
                        ||(this.report(reportsservice.quarterToDateTotalTransactions)
                          && this.report(reportsservice.quarterToDateTotalTransactions).hasOwnProperty('message')))
                        ? t('unableToFetchData') : (this.quarterToDateAvg === 0) ? '0' : this.quarterToDateAvg,
                      reportDescription: this.reportDescription(reportsservice.transactionsPerDeviceQuarterToDate)
                    },
                    'meteringPage.device.previousQuarter': {
                      report: ((this.report(reportsservice.previousQuarterTransactionsPerDevice)
                        && this.report(reportsservice.previousQuarterTransactionsPerDevice).hasOwnProperty('message'))
                        || (this.report(reportsservice.previousQuarterTotalTransactions)
                          && this.report(reportsservice.previousQuarterTotalTransactions).hasOwnProperty('message')))
                        ? t('unableToFetchData') : (this.prevQuarterAvg === 0) ? '0' : this.prevQuarterAvg,
                      reportDescription: this.reportDescription(reportsservice.transactionsPerDevicePreviousQuarter)
                    },
                    'meteringPage.device.TwoQuartersAgo': {
                      report: ((this.report(reportsservice.twoQuartersAgoTransactionsPerDevice)
                        && this.report(reportsservice.twoQuartersAgoTransactionsPerDevice).hasOwnProperty('message'))
                        || (this.report(reportsservice.twoQuartersAgoTotalTransactions)
                          && this.report(reportsservice.twoQuartersAgoTotalTransactions).hasOwnProperty('message')))
                        ? t('unableToFetchData') : (this.twoQuartersAgoAvg === 0) ? '0' : this.twoQuartersAgoAvg,
                      reportDescription: this.reportDescription(reportsservice.transactionsPerDeviceTwoQuartersAgo)
                    },
                  },
                  id: ['quarter-to-date', 'previous-quarter', 'two-quarters-ago']
                }}
            />}
          </div>
          <div className="metering-graph-content">
            <div className="metering-content-title-bar">
              <div className="metering-content-title">
                <h2>{t('deviceTrends')}</h2>
              </div>
              <TimeAggregation value={this.props.presistFilters.aggregate_by} aggregateByDays />
            </div>
            {
              // condition to hide dsn reserverd overtime graph for shark vpc
              hideDevicesReserved === 'true' ? null :
              <div ng-hide="hideDevicesReserved" className="padding-graph">
                <BarChart
                  title="meteringPage.dsnReservedOverTime"
                  width={this.widthForColumns(1)}
                  height={200}
                  data = {(this.report(reportsservice.dsnReservedOverTime)
                    && this.report(reportsservice.dsnReservedOverTime).hasOwnProperty('message'))
                    ? t('unableToFetchData') : this.report(reportsservice.dsnReservedOverTime)}
                  description={this.reportDescription(reportsservice.dsnReservedOverTime)}
                  xLabel={this.props.presistFilters.aggregate_by}
                  yLabel="devices"
                  isMeteringPage
                />
              </div>
            }
            <div className="padding-graph">
              <BarChart
                title="meteringPage.devicesProvisionedOverTime"
                width={this.widthForColumns(1)}
                height={200}
                data = {(this.report(reportsservice.devicesProvisionedOverTime)
                  && this.report(reportsservice.devicesProvisionedOverTime).hasOwnProperty('message'))
                  ? t('unableToFetchData') : this.report(reportsservice.devicesProvisionedOverTime)}
                description={this.reportDescription(reportsservice.devicesProvisionedOverTime)}
                xLabel={this.props.presistFilters.aggregate_by}
                yLabel="devices"
                isMeteringPage
              />
            </div>
            <div className="padding-graph">
              <BarChart
                title="meteringPage.devicesActivatedOverTime"
                width={this.widthForColumns(1)}
                height={200}
                data = {(this.report(reportsservice.devicesActivatedOverTime)
                  && this.report(reportsservice.devicesActivatedOverTime).hasOwnProperty('message'))
                  ? t('unableToFetchData') : this.report(reportsservice.devicesActivatedOverTime)}
                description={this.reportDescription(reportsservice.devicesActivatedOverTime)}
                xLabel={this.props.presistFilters.aggregate_by}
                yLabel="devices"
                isMeteringPage
              />
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(DevicesPage);
